export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9716.5d233056.jpg";